{
  "profile": {
    "title": "Profile",
    "subtitle": "Manage your account preferences and platform settings.",
    "loading": "Loading profile...",
    "saving": "Saving...",
    "saveChanges": "Save Changes",
    "intentPrompt": "<strong>Complete your trade profile.</strong> Tell us your side of the trade corridor, your role, size, objective and timeline. Until your side and role are set, your company is not included in matching. <link>Go to trade profile</link>",
    "errors": {
      "loadFailed": "Failed to load profile.",
      "avatarSaveFailed": "Failed to save avatar. Please try again.",
      "uploadFailed": "Upload failed.",
      "fixTradeProfile": "Please fix the highlighted trade profile fields.",
      "updateFailed": "Profile update failed. Please try again."
    },
    "settings": {
      "title": "Profile Settings",
      "logo": "Company Logo",
      "logoHint": "PNG or JPG. Square images look best.",
      "uploadLogo": "Upload company logo",
      "replace": "Replace",
      "companyName": "Company Name",
      "industry": "Industry",
      "email": "Email Address",
      "description": "Company Description",
      "descriptionPlaceholder": "Leading manufacturer of industrial equipment with 20+ years of experience in Canada-GCC trade."
    },
    "trade": {
      "title": "Trade Profile",
      "save": "Save Trade Profile"
    },
    "notifications": {
      "title": "Notification Preferences",
      "items": {
        "newMatches": {
          "title": "New match notifications",
          "description": "Get notified when new matches are found"
        },
        "complianceAlerts": {
          "title": "Compliance alerts",
          "description": "Important compliance and regulatory updates"
        },
        "marketIntelligence": {
          "title": "Market intelligence updates",
          "description": "Weekly market insights and trends"
        },
        "messages": {
          "title": "Message notifications",
          "description": "New messages from partners"
        },
        "weeklySummary": {
          "title": "Weekly summary email",
          "description": "Digest of weekly platform activity"
        }
      }
    },
    "security": {
      "title": "Security",
      "changePassword": "Change Password",
      "changePasswordDesc": "Update your account password",
      "twoFactor": "Two-Factor Authentication",
      "recommended": "Recommended",
      "twoFactorEnabled": "Enabled — manage or regenerate recovery codes",
      "twoFactorDisabled": "Not enabled",
      "activeSessions": "Active Sessions",
      "activeSessionsDesc_one": "{{count}} device currently logged in",
      "activeSessionsDesc_other": "{{count}} devices currently logged in"
    },
    "regional": {
      "title": "Regional Settings",
      "primaryMarket": "Primary Market Region",
      "primaryMarketPlaceholder": "e.g., Canada-GCC",
      "languages": {
        "en": "English",
        "ar": "Arabic",
        "fa": "Persian"
      },
      "timeZone": "Time Zone",
      "timeZonePlaceholder": "e.g., EST (UTC-5)"
    }
  },
  "trust": {
    "title": "Trust & Compliance Center",
    "subtitle": "Maintain regulatory compliance and verification status.",
    "loading": "Loading...",
    "errors": {
      "saveFailed": "Save failed.",
      "deleteFailed": "Delete failed."
    },
    "overall": {
      "ariaLabel": "Overall compliance status",
      "title": "Overall Compliance Status",
      "awarded": "A MatchPoint moderator awarded your company this badge after checking the evidence it requires.",
      "notReviewed": "Other companies see a MatchPoint badge once a moderator has checked your company and awarded one. A badge claims only what was checked. Editing a registration or shareholder sends it back for review and can pause the badge.",
      "complete": "{{value}}% Complete",
      "remaining": "{{value}}% Remaining",
      "score": "Compliance score: {{score}}"
    },
    "entities": {
      "ariaLabel": "Entity registration",
      "title": "Entity Registration",
      "add": "Add Entity",
      "loading": "Loading entities...",
      "loadFailed": "Failed to load entities.",
      "empty": "No entities yet. Click \"Add Entity\" to register one.",
      "registrationNumber": "Registration Number:",
      "subdivision": "Province / free zone:",
      "corporationType": "Corporation Type:",
      "status": "Status:",
      "registeredDate": "Registered Date:",
      "deleteFallback": "this entity"
    },
    "shareholders": {
      "ariaLabel": "Shareholder identification",
      "title": "Shareholder Identification Table",
      "add": "Add Shareholder",
      "loading": "Loading shareholders...",
      "loadFailed": "Failed to load shareholders.",
      "ownership": "Ownership %",
      "nationality": "Nationality",
      "idVerified": "ID Verified",
      "uboStatus": "UBO Status",
      "empty": "No shareholders yet. Click \"Add Shareholder\" to add one.",
      "verified": "Verified",
      "notVerified": "Not verified",
      "edit": "Edit shareholder",
      "delete": "Delete shareholder",
      "deleteFallback": "this shareholder"
    },
    "tiers": {
      "ariaLabel": "Due diligence tier progress",
      "title": "Due Diligence Tier Progress",
      "subtitle": "Complete all tiers to unlock full platform features.",
      "tier1": {
        "title": "Tier 1 - Basic Verification",
        "description": "Identity & Business Registration"
      },
      "tier2": {
        "title": "Tier 2 - Standard Compliance",
        "description": "Shareholder Verification"
      },
      "tier3": {
        "title": "Tier 3 - Advanced Due Diligence",
        "description": "Financial Records & References"
      }
    },
    "documents": {
      "ariaLabel": "Document upload and management",
      "title": "Document Upload & Management",
      "subtitle": "Upload and manage compliance documents.",
      "loadFailed": "Failed to load documents.",
      "uploadFailed": "Document upload failed.",
      "uploading": "Uploading...",
      "clickToUpload": "Click to upload documents",
      "loading": "Loading documents...",
      "name": "Document Name",
      "type": "Type",
      "uploaded": "Uploaded",
      "empty": "No documents yet. Upload a file above.",
      "view": "View document",
      "download": "Download document",
      "delete": "Delete document",
      "deleteFallback": "this document"
    }
  },
  "productService": {
    "title": "Product/Service Management",
    "subtitle": "Manage your offerings with unique HS Code validation",
    "add": "Add Product/Service",
    "overview": {
      "total": "Total Entries",
      "products": "Products",
      "services": "Services"
    },
    "errors": {
      "updateFailed": "Update failed. Please try again.",
      "createFailed": "Creation failed. Please try again.",
      "detailsMissing": "Product details are missing. Please go back.",
      "loadFailed": "Failed to load products and services. Please try again."
    },
    "dismissWarning": "Dismiss warning",
    "dismiss": "Dismiss",
    "searchPlaceholder": "Search by name, HS Code, or category...",
    "searchLabel": "Search products and services",
    "table": {
      "type": "Type",
      "hsCode": "HS Code",
      "category": "Category"
    },
    "noMatches": "No products or services match your search.",
    "typeLabel": {
      "product": "product",
      "service": "service"
    },
    "unverifiedTitle": "This HS code isn't in the official HS table. It's saved, but flagged for review.",
    "unverified": "Unverified",
    "addService": "Add Service",
    "addProduct": "Add Product",
    "estimateDuty": "Estimate duty & taxes for this code"
  },
  "addProductService": {
    "addTitle": "Add Product/Service - Details",
    "editTitle": "Edit Product/Service - Details",
    "closeModal": "Close modal",
    "type": "Type",
    "product": "Product",
    "service": "Service",
    "name": "Name",
    "namePlaceholder": "Enter product/service name",
    "description": "Description",
    "descriptionPlaceholder": "Detailed description for AI matching",
    "category": "Category",
    "categoryPlaceholder": "e.g., Industrial Equipment",
    "quantity": "Quantity",
    "quantityPlaceholder": "Enter quantity",
    "quantityUnit": "Unit",
    "quantityUnitNone": "Not specified",
    "quantityUnitHint": "The price is read per this unit, and matching converts buyers' quantities into it (kg ↔ t, l ↔ m³…).",
    "price": "Price",
    "pricePlaceholder": "Enter price",
    "currency": "Currency",
    "selectCurrency": "Select currency",
    "deliveryTime": "Delivery Time",
    "deliveryTimePlaceholder": "Enter delivery time",
    "region": "Region",
    "regionPlaceholder": "Enter region",
    "images": "Images",
    "uploading": "Uploading...",
    "uploadImages": "Upload Images",
    "imageAlt": "Upload {{index}}",
    "removeImage": "Remove image",
    "uploadFailed": "Upload failed.",
    "filesSkipped_one": "{{count}} file was skipped. Only JPG or PNG up to 10 MB are allowed.",
    "filesSkipped_other": "{{count}} files were skipped. Only JPG or PNG up to 10 MB are allowed.",
    "updating": "Updating...",
    "adding": "Adding...",
    "addService": "Add Service",
    "nextHsCode": "Next: Select HS Code"
  },
  "confirmDelete": {
    "title": "Confirm Delete",
    "defaultItemName": "this item",
    "message": "Are you sure you want to delete <strong>{{name}}</strong>? This action cannot be undone."
  },
  "addShareholder": {
    "addTitle": "Add Shareholder",
    "editTitle": "Edit Shareholder",
    "name": "Name",
    "namePlaceholder": "Enter name",
    "ownership": "Ownership %",
    "ownershipPlaceholder": "e.g., 45%",
    "nationality": "Nationality",
    "nationalityPlaceholder": "Enter nationality",
    "adding": "Adding...",
    "updating": "Updating...",
    "addSubmit": "Add Shareholder",
    "updateSubmit": "Update Shareholder"
  },
  "addEntity": {
    "addTitle": "Add Entity",
    "editTitle": "Edit Entity",
    "country": "Country",
    "selectCountry": "Select a country",
    "subdivision": "Province, state or free zone (optional)",
    "subdivisionPlaceholder": "e.g. {{example}}",
    "subdivisionHint": "Where the company is registered within the country, e.g. CA-QC for Quebec or AE-DMCC for a Dubai free zone. It tells MatchPoint which official registry to check.",
    "registrationNumber": "Registration Number",
    "registrationNumberPlaceholder": "Enter registration number",
    "corporationType": "Corporation Type",
    "corporationTypeSuggestions": "Suggestions: {{suggestions}}…",
    "corporationTypePlaceholder": "Enter corporation type",
    "registeredDate": "Registered Date",
    "adding": "Adding...",
    "updating": "Updating...",
    "addSubmit": "Add Entity",
    "updateSubmit": "Update Entity"
  },
  "changePassword": {
    "title": "Change Password",
    "success": "Password changed successfully.",
    "done": "Done",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "hint": "At least 8 characters.",
    "confirmPassword": "Confirm new password",
    "submit": "Change Password",
    "errors": {
      "failed": "Failed to change password.",
      "tooShort": "New password must be at least 8 characters.",
      "mismatch": "New password and confirmation do not match.",
      "sameAsCurrent": "New password must be different from the current password."
    }
  },
  "twoFactor": {
    "title": "Two-Factor Authentication",
    "codeLabel": "Authentication code",
    "errors": {
      "setupFailed": "Failed to start 2FA setup.",
      "invalidCode": "Invalid code.",
      "invalidPasswordOrCode": "Invalid password or code."
    },
    "status": {
      "enabled": "2FA is enabled on your account.",
      "hint": "Use your authenticator app at sign-in. Lost access? Use one of the recovery codes you saved when enabling 2FA, or regenerate a fresh batch below.",
      "regenerate": "Regenerate recovery codes"
    },
    "setup": {
      "hint": "Add an extra layer to your sign-in. You'll scan a QR code into an authenticator app (Google Authenticator, 1Password, Authy, etc.) and confirm a 6-digit code.",
      "preparing": "Preparing…",
      "start": "Get started"
    },
    "verify": {
      "qrAlt": "2FA QR code",
      "manualKey": "Or enter this key manually: <code>{{secret}}</code>",
      "codeLabel": "Enter the 6-digit code from your app",
      "enabling": "Enabling…",
      "submit": "Enable 2FA"
    },
    "codes": {
      "warning": "Save these recovery codes now. They are shown <strong>only once</strong> and let you sign in if you lose access to your authenticator.",
      "copy": "Copy",
      "download": "Download .txt",
      "saved": "I saved them"
    },
    "disable": {
      "hint": "Disabling 2FA needs both your password and a current 6-digit code so a hijacked session can't strip protection off your account.",
      "password": "Password",
      "disabling": "Disabling…",
      "submit": "Disable 2FA"
    },
    "regenerate": {
      "hint": "This invalidates every previously-issued recovery code. Confirm with a current 6-digit code.",
      "generating": "Generating…",
      "submit": "Generate codes"
    }
  },
  "billing": {
    "title": "Subscription & Billing",
    "notEnabled": "Billing is not yet enabled on this environment.",
    "activeSubscription": "Active subscription",
    "endsOn": "Ends on {{date}}",
    "renewsOn": "Renews on {{date}}",
    "hideInvoices": "Hide invoices ↑",
    "viewHistory": "View billing history →",
    "opening": "Opening…",
    "managePlan": "Manage Plan",
    "noPlan": "You don't have an active plan yet.",
    "loadingPlans": "Loading plans…",
    "noPlans": "No plans are currently published. Contact support to subscribe.",
    "previousPlan": "Your previous plan ({{plan}}) is <badge></badge>.",
    "subscriptionFallback": "subscription",
    "redirecting": "Redirecting…",
    "subscribe": "Subscribe",
    "loadingInvoices": "Loading invoices…",
    "noInvoices": "No invoices yet.",
    "table": {
      "invoice": "Invoice",
      "period": "Period",
      "amount": "Amount"
    }
  }
}
